"use client";

import { Title } from "@/components/common/typography/Title";
import { PrimaryButton } from "@/components/common/buttons/PrimaryButton";

export const TemporaryInscription = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-10 overflow-x-hidden bg-secondary px-4 py-14 sm:px-6 sm:py-16 md:px-12 md:py-20 lg:px-24 xl:px-32">
      <div className="flex w-full flex-col items-center justify-center gap-10">
        <Title
          text={["Inscription", "2025-2026"]}
          position="center"
          textPosition="center"
          color="primary"
        />

        <div className="flex w-full max-w-3xl flex-col items-center justify-center gap-6 rounded-xl bg-white p-6 shadow-lg sm:p-8">
          <div className="flex flex-col items-center gap-4 text-center">
            <h3 className="text-lg font-medium text-primary sm:text-xl md:text-2xl">
              Inscription Saison 2025-2026
            </h3>

            <p className="text-sm leading-relaxed text-primary sm:text-base">
              Les inscriptions pour la saison 2025-2026 sont disponibles.
            </p>

            <p className="text-sm leading-relaxed text-primary sm:text-base">
              Vous pouvez déjà remplir le formulaire d&apos;inscription ou
              réinscription pour la saison 2025-2026 en cliquant sur le bouton
              ci-dessous.
            </p>

            <div className="mt-6 flex w-full flex-col gap-4 sm:flex-row sm:justify-center">
              <div className="w-full sm:w-auto">
                <PrimaryButton
                  text="ACCÉDER À L'INSCRIPTION"
                  variant="unique"
                  navigateTo="https://tkdinscription.vfeapps.fr/q_inscription/"
                  target="_blank"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
